import { useEffect, useState } from "react";
import { Loader2, Plus, RotateCcw, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const AllowedUnitsCard = () => {
  const [units, setUnits] = useState(null);
  const [def, setDef] = useState([]);
  const [add, setAdd] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/upload/allowed").then((r) => { setUnits(r.data.units); setDef(r.data.default); }); }, []);
  const push = () => {
    const u = add.trim().toUpperCase().replace(/^UP3\s*/, "");
    if (u && !units.includes(u)) setUnits([...units, u]);
    setAdd("");
  };
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/upload/allowed", { units }); setUnits(data.units); toast.success("Daftar UP3 upload disimpan"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section data-testid="allowed-units-card" className="rounded-xl border bg-card p-5 shadow-sm">
      <h2 className="font-heading text-lg font-semibold">UP3 yang Diizinkan pada Upload Data</h2>
      <p className="mt-1 text-sm text-muted-foreground">Hanya UP3 di daftar ini yang ikut diproses dari file upload; UP3 lain dibuang.</p>
      {!units ? <Loader2 className="mt-4 h-5 w-5 animate-spin" /> : (
        <>
          <div className="mt-4 flex flex-wrap gap-2">
            {units.map((u) => (
              <span key={u} data-testid={`allowed-unit-${u.toLowerCase().replace(/\s+/g, "-")}`} className="inline-flex items-center gap-1 rounded-full border bg-muted px-3 py-1 text-xs font-medium">
                {u}
                <button type="button" data-testid={`allowed-unit-remove-${u.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setUnits(units.filter((x) => x !== u))} className="text-muted-foreground hover:text-rose-600"><X className="h-3 w-3" /></button>
              </span>
            ))}
          </div>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row">
            <Input data-testid="allowed-unit-input" placeholder="Nama UP3, mis. PONDOK KOPI" value={add} onChange={(e) => setAdd(e.target.value)} onKeyDown={(e) => e.key === "Enter" && push()} className="sm:w-72" />
            <Button data-testid="allowed-unit-add" variant="outline" onClick={push}><Plus className="mr-1 h-4 w-4" />Tambah</Button>
            <Button data-testid="allowed-unit-reset" variant="ghost" onClick={() => setUnits(def)}><RotateCcw className="mr-1 h-4 w-4" />Default (16 UP3)</Button>
            <Button data-testid="allowed-unit-save" onClick={save} disabled={busy || !units.length}>{busy && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}Simpan</Button>
          </div>
          <p className="mt-2 text-xs text-muted-foreground">{units.length} UP3 diizinkan</p>
        </>
      )}
    </section>
  );
};
